import StoreProc from './StoreProc'

const StorePlugin = {}

StorePlugin.install = function (Vue, options) {
  Vue.prototype.$_sp = StoreProc
}

export default StorePlugin
